import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import Grid from "../shared/grid"
import FadedTitle from "../shared/faded-title"
import SectionDivider from "../shared/section-divider"
import Link from "../shared/link"
import {
  ContentBackground,
  FadedTitleWrapper,
  StyledFluid,
  draftPubImageStyle,
  previewMapImageStyle,
  manageEventsImageStyle,
  DetailsBody,
  DetailsTitle,
  DetailsWrapper,
  draftPubStyle,
  previewMapsStyle,
  manageEventsStyle,
  linkStyle,
} from "./map-accuracy.style"
import externalLinks from "../../external-links"

export const StyledFadedTitle = styled(FadedTitle)`
  text-align: center;
  color: var(--light-background);
`

const MapAccuracy = () => {
  const {
    draftPubSrc,
    previewMapSrc,
    manageEventsSrc,
    editorFade
  } = useStaticQuery(graphql`
    query {
      draftPubSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/draft_publish.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      previewMapSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/preview_maps.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      manageEventsSrc: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/0_manage events.png"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      editorFade: file(
        relativePath: {
          eq: "1_SOLUTIONS/Mapping CMS - Internal Pages/Map Editor/editor_fade_title_dark.svg"
        }
      ) {
        publicURL
      }
    }
  `)
  return (
    <>
      <SectionDivider />
      <ContentBackground>
        <Grid>
          <FadedTitleWrapper>
            <FadedTitle 
              title="Maintain Map Accuracy"
              image={editorFade.publicURL}
              alt="Editor"
              fadeSettings={{ lg: "center" }}
              textAlign="center"
            />
          </FadedTitleWrapper>
          <StyledFluid
            styleModifier={draftPubImageStyle}
            imgStyle={{ objectFit: "contain" }}
            fluid={draftPubSrc.childImageSharp.fluid}
            alt="An image showing the difference between a draft and published map."
          />
          <DetailsWrapper styleModifier={draftPubStyle}>
            <DetailsTitle>Draft & Publish</DetailsTitle>
            <DetailsBody>
              This feature enables more collaboration and efficiency within the
              Map Editor. Draft Mode allows you to pre-plan venue changes
              without compromising any live data.
            </DetailsBody>
            <Link href={externalLinks.hubspot.product101DraftPublish} styleModifier={linkStyle}>
              {" "}
              Read the Product 101 Blog
            </Link>
          </DetailsWrapper>
          <StyledFluid
            styleModifier={previewMapImageStyle}
            imgStyle={{ objectFit: "contain" }}
            fluid={previewMapSrc.childImageSharp.fluid}
            alt="An image showing a map being previewed before it is live."
          />
          <DetailsWrapper styleModifier={previewMapsStyle}>
            <DetailsTitle>Preview Maps</DetailsTitle>
            <DetailsBody>
              Preview your maps before they go live. Users can render the
              updated venue maps across multiple perspectives and archive data
              with the snapshot feature.
            </DetailsBody>
          </DetailsWrapper>
          <StyledFluid
            styleModifier={manageEventsImageStyle}
            imgStyle={{ objectFit: "contain" }}
            fluid={manageEventsSrc.childImageSharp.fluid}
            alt="An image showing event details."
          />
          <DetailsWrapper styleModifier={manageEventsStyle}>
            <DetailsTitle>Manage Events</DetailsTitle>
            <DetailsBody>
              Add short-term locations to your venue map with our simple draw
              tools. Include dates, descriptions, and other information in the
              location details and simply delete when the event is over.
            </DetailsBody>
          </DetailsWrapper>
        </Grid>
      </ContentBackground>
      <SectionDivider flip />
    </>
  )
}

export default MapAccuracy